import { fromJS } from 'immutable';
import * as actionTypes from 'modules/Profile/redux/relations/actionTypes';
import initialState from 'modules/Profile/redux/relations/initialState';
import { createReducer } from 'utils/redux';

const onStart = (state) => state.setIn(['list', 'loading'], true).setIn(['list', 'error'], null);

const onSuccess = (state, { payload }) =>
  state.setIn(['list', 'data'], fromJS(payload)).setIn(['list', 'loading'], false);

const onError = (state, { payload }) =>
  state.setIn(['list', 'loading'], false).setIn(['list', 'error'], fromJS(payload));

const onActionStart = (state) =>
  state.setIn(['action', 'loading'], true).setIn(['action', 'error'], null);

const onActionSuccess = (state, { payload }) => {
  // TODO: Implement model update when BE is ready
  // const dataByType = {
  //   create: (state, data) => state,
  //   confirm: (state, data) => state,
  //   refuse: (state, data) => state,
  // };
  //
  // return state
  //   .setIn(['action', 'data'], fromJS(dataByType[type](state, data)))
  //   .setIn(['action', 'loading'], false);
  return state.setIn(['action', 'data'], fromJS(payload)).setIn(['action', 'loading'], false);
};

const onActionError = (state, { payload }) =>
  state.setIn(['action', 'loading'], false).setIn(['action', 'error'], fromJS(payload));

const onGetActive = (state) =>
  state.setIn(['active', 'loading'], true).setIn(['active', 'error'], null);

const onGetActiveSuccess = (state, { payload }) =>
  state.setIn(['active', 'data'], fromJS(payload)).setIn(['active', 'loading'], false);

const onGetActiveError = (state, { payload }) =>
  state.setIn(['active', 'error'], fromJS(payload)).setIn(['active', 'loading'], false);

export default createReducer(initialState, {
  [actionTypes.GET_RELATIONS]: onStart,
  [actionTypes.GET_RELATIONS_SUCCESS]: onSuccess,
  [actionTypes.GET_RELATIONS_FAILURE]: onError,
  [actionTypes.UPDATE_RELATIONS]: onActionStart,
  [actionTypes.UPDATE_RELATIONS_SUCCESS]: onActionSuccess,
  [actionTypes.UPDATE_RELATIONS_FAILURE]: onActionError,
  [actionTypes.GET_ACTIVE]: onGetActive,
  [actionTypes.GET_ACTIVE_SUCCESS]: onGetActiveSuccess,
  [actionTypes.GET_ACTIVE_FAILURE]: onGetActiveError,
});
